import 'expo-router/entry';
import 'react-native-reanimated';

import { UnistylesRuntime } from 'react-native-unistyles';

import { configure as configureUnistyles } from '@squire/ui/configure';
import { theme } from '@squire/ui/theme';

import '@/constants/devMenu';

import { config } from './src/constants/config';

import './src/constants/i18n';
import './src/constants/unistyles';

configureUnistyles({
  settings: {
    // initialTheme: UnistylesRuntime.colorScheme === 'dark' ? 'dark' : 'light',
  },
  themes: config.colors,
  breakpoints: theme.breakpoints,
});
